export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq3a-Forensic-Blank.ddb9103e.png";